import {Component, EventEmitter, forwardRef, Input, NgModule, Output} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

export class SdSlideToggleChange {
  constructor(public source: SdSlideToggle, public checked: boolean) {}
}

@Component({
  selector: 'sd-slide-toggle',
  standalone: true,
  template: `
    <label class="inline-flex cursor-pointer items-center gap-2 text-sm">
      <span
        class="relative h-5 w-9 rounded-full transition"
        [class.bg-neutral-900]="checked"
        [class.bg-neutral-300]="!checked"
      >
        <span
          class="absolute top-0.5 h-4 w-4 rounded-full bg-white shadow transition"
          [style.left.px]="checked ? 16 : 2"
        ></span>
      </span>
      <input type="checkbox" class="sr-only" [checked]="checked" [disabled]="disabled" (change)="onNative($event)" />
      <span><ng-content></ng-content></span>
    </label>
  `,
  host: {class: 'sd-slide-toggle inline-flex'},
  providers: [{provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SdSlideToggle), multi: true}],
})
export class SdSlideToggle implements ControlValueAccessor {
  @Input() checked = false;
  @Input() disabled = false;
  @Input() color: string | undefined;
  @Output() change = new EventEmitter<SdSlideToggleChange>();
  @Output() toggleChange = new EventEmitter<void>();
  private onChange: (v: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(v: boolean): void {
    this.checked = !!v;
  }
  registerOnChange(fn: (v: boolean) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onNative(event: Event): void {
    this.checked = (event.target as HTMLInputElement).checked;
    this.onChange(this.checked);
    this.onTouched();
    this.change.emit(new SdSlideToggleChange(this, this.checked));
    this.toggleChange.emit();
  }
}

@NgModule({
  imports: [SdSlideToggle],
  exports: [SdSlideToggle],
})
export class SdSlideToggleModule {}
